import { render } from "./DebitPaymentTab.vue?vue&type=template&id=68914c32&scoped=true&ts=true"
import script from "./DebitPaymentTab.vue?vue&type=script&lang=ts"
export * from "./DebitPaymentTab.vue?vue&type=script&lang=ts"

import "./DebitPaymentTab.vue?vue&type=style&index=0&id=68914c32&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68914c32"]])

export default __exports__